import { ACTING_TONIGHT_OPTIONS } from '../ACTING_TONIGHT_OPTIONS';
import { ActingTonightOptionIdType } from '../types';

export const getActingTonightChoiceIdByTitle = (
  title: string,
): ActingTonightOptionIdType | null => {
  const option = ACTING_TONIGHT_OPTIONS.find(
    (option) => option.title === title,
  );
  return option ? option.id : null;
};
